export default {
    setError: (propertyName, error) => ({
        type: 'SET_ERROR',
        propertyName: propertyName,
        error: error
    })
};
